import { render, staticRenderFns } from "./networks.vue?vue&type=template&id=2bb36d16&scoped=true"
import script from "./networks.vue?vue&type=script&lang=js"
export * from "./networks.vue?vue&type=script&lang=js"
import style0 from "./networks.vue?vue&type=style&index=0&id=2bb36d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb36d16",
  null
  
)

export default component.exports